import { CircleX } from "lucide-react";

const ProcessSheriffModal = ({ handleCancel, handleConfirm }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div className="schedule-form-wrapper process-sheriff-modal">
        <div className="schedule-form">
          <div className="schedule-form-header">
            <p>Process</p>
            <button type="button" onClick={handleCancel}>
              <CircleX />
            </button>
          </div>
          <div className="deputy-sheriff-modal-container">
            <p className="suit-number">
              <span style={{ fontWeight: 600 }}>Suit number:</span>{" "}
              ID/ADR/1470/2020
            </p>

            <div className="process-sheriff-input-group-container">
              <div className="process-sheriff-input-group">
                <input type="checkbox" id="no-motion-pending" />

                <label htmlFor="no-motion-pending">
                  I have checked the Physical File (Manual) AND the System
                  (Online) and confirmed there is <span>NO</span> Motion for
                  Stay of Execution or Appeal pending
                </label>
              </div>
              <div
                className="process-sheriff-input-group"
                style={{
                  marginTop: "16px",
                }}
              >
                <input type="checkbox" id="motion-pending" />

                <label htmlFor="motion-pending">
                  I have checked the Physical File (Manual) AND the System
                  (Online) and confirmed there is Motion for Stay of Execution
                  or Appeal pending.
                </label>
              </div>
            </div>

            <p className="time-stamp ">Time stamp: 17/11/2025 10:00am</p>
            <button
              style={{
                height: "50px",
              }}
              className="process-sheriff-modal-button"
              type="button"
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSheriffModal;
